import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./default.css";
import locationIcon from "../images/active_arrow_up.png"; 
import signal from "../images/single.png";
import network from "../images/network.png";
import battery from "../images/battery.png";
import arrowBack from "../images/arrow_back.png";
import notifications from "../images/Notifications none.png";
import expandMore from "../images/expand_more.png";
import arrowRightLight from "../images/arrow_right_light.png";
import arrowRightDark from "../images/arrow_right_dark.png";
import { setAuthToken } from "../helpers/setAuthToken";
import { generateJwtToken } from "../generateJwt";
import { useState } from "react";

// 1. Static Helpers
const getValue = (value, defaultValue = "") => value ?? defaultValue;

const getNestedValue = (obj, key, defaultValue = "") => {
  return obj?.[key] ?? defaultValue;
};


export default function ClaimFiling() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};

  //const userPreferredLanguage = getValue(data.insuredLanguage);
  const isAgentFiling = !!data.AgentActor && getValue(data.AgentActor.UserType) === 'AGENT';

  const moveBack = () => {
    navigate("/MyProfile", { state: data });
  };

  const [externalClaimId, setExternalClaimId] = useState("");
  // 2. SHARED SECURITY HELPER
  // This ensures both View and Register use the same Token structure
  const prepareAuthHeader = async () => {
    const actorId = isAgentFiling ? getValue(data.AgentActor.id) : getValue(data.id);
    const subjectId = getValue(data.id);

    const identity = {
      policyNumber: getValue(data.policyNumber),
      userEmail: isAgentFiling ? getValue(data.AgentActor.email) : getValue(data.email),
      companyCode: data.companyCode,
      id: actorId,
      userType: isAgentFiling ? getValue(data.AgentActor.UserType) : getValue(data.UserType),
      userFullName: isAgentFiling ? `${getValue(data.AgentActor.firstName)} ${getValue(data.AgentActor.lastName)}` : `${getValue(data.firstName)} ${getValue(data.lastName)}`,
      onBehalfOfId: isAgentFiling ? subjectId : null,
      userPreferredLanguage: isAgentFiling 
        ? (getValue(data.AgentActor.preferredLanguage) || null) 
        : (getValue(data.preferredLanguage) || null)
    };

    const jwt = await generateJwtToken(identity);
    return {
      "Content-type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${jwt}`
    };
  };

  // 2. Modern Approach: Build Payload as a JavaScript Object
  const buildRequestPayload = (data , claimId = null) => {
    if (claimId) {
          return {
            ClaimReference: claimId 
          };
    }
    return {
        Type: ["Residential"],
        HeadOfficeCompanyID: "",
        CompanyID: getValue(data.companyCode),
        FlatDeductible: data.flatDeductible != null ? String(getValue(data.flatDeductible)) : "0",
        ExternalSystemCompanyCode: "",
        CompanyName: getValue(data.companyName),
        Phone: "",
        BuiltYear: "1976",
        InsuredCompanyName: "",
        InsuredTitle: getValue(data.title),
        InsuredFirstName: getValue(data.firstName),
        InsuredLastName: getValue(data.lastName),
        InsuredEmail: getValue(data.email),
        InsuredTitle2: "",
        InsuredFirstName2: "",
        InsuredLastName2: "",
        InsuredHomePhone: getValue(data.phone1),
        InsuredBusinessPhone: "",
        InsuredMobilePhone: "",
        InsuredOtherPhone: "",
        InsuredOtherPhoneLabel: "Other",
        InsuredPreferredPhone: "None",

        InsuredLanguage: getValue(data.insuredLanguage),

        PolicyNumber: getValue(data.policyNumber),
        PolicyStartDate: getValue(data.policyStartDate),
        PolicyEndDate: getValue(data.policyEndDate),
        PolicyTimesRenewed: 0,
        InsuredAddress: {
          Country: getNestedValue(data.insuredAddress, "country"),
          State: getNestedValue(data.insuredAddress, "state"),
          Line1: getNestedValue(data.insuredAddress, "line1"),
          City: getNestedValue(data.insuredAddress, "city"),
          Island: String(getNestedValue(data.insuredAddress, "island")),
          ZipCode: getNestedValue(data.insuredAddress, "zipCode"),
        },
        LossAddress: {
          Country: getNestedValue(data.lossAddress, "country"),
          State: getNestedValue(data.lossAddress, "state"),
          Line1: getNestedValue(data.lossAddress, "line1"),
          Line2: getNestedValue(data.lossAddress, "line2"),
          City: getNestedValue(data.lossAddress, "city"),
          ZipCode: getNestedValue(data.lossAddress, "zipCode"),
          Latitude: getNestedValue(data.lossAddress, "latitude"),
          Longitude: getNestedValue(data.lossAddress, "longitude"),
        },
        LossDate: getValue(data.lossDate),
        LossType: getValue(data.lossType),
        LossDesc: getValue(data.lossDesc)
    }
    
  };

  const LaunchSelfServeApplication = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  // 3. UPDATED VIEW CLAIMS (Now with JWT)
  const viewClaims = async () => {
    try {
      const headers = await prepareAuthHeader();
      const response = await axios.get('https://app-selfserve-np-eus.ngsdevapps.net/api/InitialInformation/ApplicationUrl/ViewClaims', {
        /* params: {
          PolicyNumber: getValue(data.policyNumber),
          CompanyCode: data.companyCode 
        }, */
        headers: headers // Reusing the same security logic
      });
      LaunchSelfServeApplication(response.data);
    } catch (error) {
      console.error('View Claims Error:', error);
      alert(error?.response?.data || "Unable to retrieve claims.");
    }
  };

  // 4. UPDATED REGISTER CLAIM
  const registerClaim = async () => {
    try {
      const headers = await prepareAuthHeader();
      const payload = buildRequestPayload(data);
      
      const response = await axios.post("https://app-selfserve-np-eus.ngsdevapps.net/api/InitialInformation/ApplicationUrl", payload, {
        headers: headers
      });
      LaunchSelfServeApplication(response.data);
    } catch (error) {
      alert(error?.response?.data || "Error filing claim.");
    }
  };

  const postCreateClaim = async () => {
    if (!externalClaimId.trim()) {
      alert("Please enter a Claim Reference.");
      return;
    }

  try {
      const headers = await prepareAuthHeader();
      // Create a specific payload for Post-Create ONLY
      const payload = {
        ReferenceId: externalClaimId.trim()
      };
    
    const response = await axios.post(
    "https://app-selfserve-np-eus.ngsdevapps.net/api/v1/InitialInformation/PV/ApplicationUrl",

      payload, 
      { headers : headers}
    );
    
    LaunchSelfServeApplication(response.data);
  } catch (error) {
    console.error('Post-Create Error:', error);
    alert(error?.response?.data || "Error processing external claim.");
  }
};

  return (
    <div style={{ backgroundColor: "#134c86", width: "100%", float: "left", minHeight: "100vh" }}>
      {/* Status Bar */}
      <div className="Status_bar">
        <div className="time">
          <ul><li>9:40</li><li><img src={locationIcon} width="14" alt="loc" /></li></ul>
        </div>
        <div className="network text-align-right">
          <ul>
            <li><img src={signal} width="20" alt="sig" /></li>
            <li><img src={network} width="24" alt="net" /></li>
            <li><img src={battery} width="28" alt="bat" /></li>
          </ul>
        </div>
      </div>

      {/* Header */}
      <div className="trailing_icons">
        <ul>
          <li onClick={moveBack}><img src={arrowBack} width="24" alt="back" /></li>
          <li><h4> File a claim </h4></li>
          <li><img src={notifications} width="24" alt="notif" /></li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="content_box">
        <div className="claim_row">
          <div className="claim_head"><h4>Product Type</h4></div>
          <div className="claim_content">
            <div className="loop_claim">
              <ul><li> Policy Plan </li><li className="text-align-right"> Home Insurance</li></ul>
            </div>
            <div className="loop_claim">
              <ul><li> Policy No. </li><li className="text-align-right"> {data.policyNumber}</li></ul>
            </div>
            <div className="loop_claim">
              <ul><li> Status </li><li className="text-align-right"> {data.policyStatus}</li></ul>
            </div>
          </div>
        </div>
        <div class="claim_row">
          <div class="claim_head">
            <h4>Policy Date</h4>
          </div>

          <div class="claim_content">
            <div class="loop_claim">
              <ul>
                <li> Start Date</li>
                <li class="text-align-right"> {data.policyStartDate}</li>
              </ul>
            </div>
            <div class="loop_claim">
              <ul>
                <li> Expiry Date </li>
                <li class="text-align-right"> {data.policyEndDate}</li>
              </ul>
            </div>
            <div class="loop_claim">
              <ul>
                <li> Cover limit </li>
                <li class="text-align-right"> {data.coverLimit}</li>
              </ul>
            </div>
            <div class="loop_claim">
              <ul>
                <li> Cover Type </li>
                <li class="text-align-right">
                  {" "}
                  Buildings with Accidental Damage
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="claim_row">
          <div class="claim_head ">
            <label for="item-3" class="toggle">
              <h4 class="dflex_claim">
                Insured Address{" "}
                <span>
                  <img src={expandMore} />
                </span>
              </h4>
            </label>
          </div>
          <input type="checkbox" name="one" id="item-3" class="hide-input" />
          <div class="claim_content toggle-el">
            <div class="loop_claim">
              <p>{getNestedValue(data.insuredAddress ,"line1")}</p>
              <p> {getNestedValue(data.insuredAddress , "city")} </p>
              <p> {getNestedValue(data.insuredAddress , "state")} </p>
              <p> {getNestedValue(data.insuredAddress , "zipCode")} </p>
              <p> {getNestedValue(data.insuredAddress , "country")} </p>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="file_claim_btngrp">
          <button className="btn_primary" type="button" onClick={registerClaim}>
            File New Claim <span><img src={arrowRightLight} alt="arrow" /></span>
          </button>
          
          <button className="btn_primary" type="button" onClick={viewClaims}>
            View existing claims <span><img src={arrowRightDark} alt="arrow" /></span>
          </button>
        </div>
        {/* 4. New Post-Create Section */}
        <div className="claim_row" style={{ marginTop: "20px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px" }}>
          <h4>Post Create Claim (P&V Workflow)</h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
            <input 
              type="text" 
              placeholder="Enter Claim Reference (e.g. PV-12345)" 
              value={externalClaimId}
              onChange={(e) => setExternalClaimId(e.target.value)}
              style={{ padding: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
            <button className="btn_primary" type="button" onClick={postCreateClaim}>
              Submit External Claim
              <span><img src={arrowRightLight} alt="arrow" /></span>
            </button>
          </div>
          </div>
      </div>
    </div>
  );
}